<template>
  <img v-if="icon" :src="logo" class="logo" alt="Logo Trioteca" />
  <img v-else :src="logoFull" class="logo" alt="Logo Trioteca" />
</template>

<script>
import { computed } from '@vue/composition-api';
export default {
  props: {
    icon: {
      type: Boolean,
      default: false,
    },
    white: {
      type: Boolean,
      default: false,
    },
  },

  setup(props) {
    const { white } = props;

    return {
      logo: computed(() => (white ? 'img/web/logo-white.svg' : 'img/web/logo-yellow.svg')),
      logoFull: computed(() => (white ? 'img/web/trioteca-white.svg' : 'img/web/trioteca-yellow.svg')),
    };
  },
};
</script>

<style scoped lang="postcss">
.logo {
  @apply w-full h-auto;
}
</style>
